import { render, staticRenderFns } from "./ColumnDlg.vue?vue&type=template&id=edc93322&"
import script from "./ColumnDlg.vue?vue&type=script&lang=js&"
export * from "./ColumnDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports